// Card payments run on Stripe test keys until the business is registered to
// sell: the site then says so and gives the test card. Set
// VITE_PAYMENTS_LIVE=true in Vercel only together with a live key (and
// STRIPE_ALLOW_LIVE=true) in Supabase.
export const PAYMENTS_LIVE = import.meta.env.VITE_PAYMENTS_LIVE === 'true';
